import './App.css';
import { analytics } from './firebase';
import { logEvent } from "firebase/analytics";

function Home() {
  // Optional: log homepage view
  try {
    logEvent(analytics, 'page_view', { page: 'home' });
  } catch (e) {
    console.warn('Analytics not available', e);
  }

  return (
    <div className="app-container">

      {/* HERO SECTION */}
      <header className="hero">
        <div className="hero-content">
          <img src="/app-logoss.jpg" alt="NexaFord Icon" className="app-icon" />
          <h1>NexaFord — by ORPO Corporation</h1>
          <p className="hero-sub">
            The ultimate platform to discover the best AI tools and websites — all in one place.
          </p>
          <p className="hero-stats">Join over <strong>1 million+</strong> users globally</p>

          <div className="hero-buttons">
            <a href="#features" className="learn-btn">Learn More</a>
            
            {/* GOOGLE PLAY DOWNLOAD BUTTON */}
            <a 
              href="https://play.google.com/store/apps/details?id=com.nexaford.webstore" 
              target="_blank" 
              rel="noopener noreferrer"
              className="play-store-link"
            >
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get Webify on Google Play" 
                className="play-store-badge"
              />
            </a>
            
            <a href="#contact" className="contact-btn">Contact Sales</a>
          </div>
        </div>
      </header>

      {/* NAV TABS / QUICK LINKS */}
      <nav className="quick-nav">
        <a href="#features">Why NexaFord</a>
        <a href="#products">Products</a>
        <a href="#services">Services</a>
        <a href="#careers">Careers</a>
        <a href="#contact">Contact</a>
      </nav>

      {/* FEATURES SECTION */}
      <section id="features" className="features">
        <h2>Why NexaFord?</h2>
        <p className="lead">We curate and surface the best AI tools, web apps, and integrations so teams and creators can build faster.</p>

        <div className="feature-list">
          <div className="feature">
            <img src="/icons/ai-tools.svg" alt="AI Tools Icon" className="feature-icon"/>
            <h3>Curated AI Tools</h3>
            <p>Access high-quality AI services, verified and categorized for immediate discovery and use.</p>
          </div>

          <div className="feature">
            <img src="/icons/all-in-one.svg" alt="All-in-One Icon" className="feature-icon"/>
            <h3>All-in-One Platform</h3>
            <p>Discover websites, web apps, and AI tools without jumping between stores and dashboards.</p>
          </div>

          <div className="feature">
            <img src="/icons/security.svg" alt="Security Icon" className="feature-icon"/>
            <h3>Safe & Secure</h3>
            <p>We vet tooling for security and reliability — and surface vendor links rather than hosting third-party content.</p>
          </div>
        </div>
      </section>

      {/* SERVICES SECTION */}
      <section id="services" className="services">
        <h2>Our Services</h2>
        <div className="service-grid">
          <div className="service-card">
            <h3>AI & ML Development</h3>
            <p>Custom model development, fine-tuning, inference pipelines, and MLOps to productionize AI.</p>
          </div>
          <div className="service-card">
            <h3>Cloud Infrastructure</h3>
            <p>Scalable cloud design, cost optimization, and secure deployment for production workloads.</p>
          </div>
          <div className="service-card">
            <h3>Integration & APIs</h3>
            <p>Connect your systems with reliable APIs, single sign-on, and developer tooling.</p>
          </div>
          <div className="service-card">
            <h3>Design & UX</h3>
            <p>User-centered product, interface and interaction design to improve adoption and engagement.</p>
          </div>
        </div>
      </section>

      {/* PRODUCTS SECTION */}
      <section id="products" className="products">
        <h2>Products</h2>
        <div className="product-cards">
          <div className="product-card">
            <img src="/icons/webstore.svg" alt="WebStore Icon"/>
            <h4>WebStore</h4>
            <p>Discover, launch, and integrate web apps and AI tools instantly in a curated catalog.</p>
          </div>
          <div className="product-card">
            <img src="/icons/nexaford.svg" alt="NexaFord Icon"/>
            <h4>NexaFord</h4>
            <p>An adaptive, modular platform to unify multiple apps and tools into a contextual workspace.</p>
          </div>
          <div className="product-card">
            <img src="/icons/enterprise.svg" alt="Enterprise Icon"/>
            <h4>ORPO Enterprise Suite</h4>
            <p>Tailored enterprise features including SSO, audit logs, compliance, and priority support.</p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="testimonials">
        <h2>Customer Testimonials</h2>
        <div className="testimonial-grid">
          <blockquote className="testimonial">
            <p>“NexaFord helped us reduce time to market and streamline tool adoption across our org.”</p>
            <cite>— Head of Product, GlobalTech</cite>
          </blockquote>
          <blockquote className="testimonial">
            <p>“The ORPO team built a custom ML pipeline for us that saved hundreds of manual hours monthly.”</p>
            <cite>— CTO, PrimeTel Group</cite>
          </blockquote>
        </div>
      </section>

      {/* LEADERSHIP SECTION */}
      <section className="team">
        <h2>Leadership</h2>
        <div className="team-grid">
          <div className="team-member">
            <img src="/team/ceo.jpg" alt="Peter Omondi Odhiambo"/>
            <h3>Peter Omondi Odhiambo</h3>
            <p>Founder & CEO</p>
          </div>
          <div className="team-member">
            <img src="/team/cto.jpg" alt="CTO"/>
            <h3>Chief Technology Officer</h3>
            <p>Head of Engineering & AI</p>
          </div>
          <div className="team-member">
            <img src="/team/head-design.jpg" alt="Head of Design"/>
            <h3>Head of Design</h3>
            <p>Product & UX Lead</p>
          </div>
        </div>
      </section>

      {/* CAREERS SECTION */}
      <section id="careers" className="careers">
        <h2>Careers</h2>
        <p>We're building intelligent systems that empower people — join us.</p>
        <ul>
          <li><strong>Frontend Engineer</strong> — React, TypeScript</li>
          <li><strong>Backend Engineer</strong> — Node.js / Python</li>
          <li><strong>Machine Learning Engineer</strong> — model training & deployment</li>
          <li><strong>Product Designer</strong> — UX, Research, Design Systems</li>
        </ul>
        <p>Apply: <a href="mailto:nexafords@gmail.com">nexafords@gmail.com</a></p>
      </section>

      {/* CONTACT SECTION */}
      <section id="contact" className="contact">
        <h2>Contact Us</h2>
        <p>Email: <a href="mailto:nexafords@gmail.com">nexafords@gmail.com</a></p>
        <p>Location: Nairobi, Kenya</p>
      </section>

      {/* LEGAL & POLICIES SECTION */}
      <section id="legal" className="legal">
        <h2>Legal & Policies</h2>

        <article id="privacy-policy" className="policy">
          <h3>Privacy Policy</h3>
          <p>Effective date: November 25, 2025</p>
          <h4>1. Introduction</h4>
          <p>ORPO Corporation (“we”, “us”, “our”) operates NexaFord and WebStore. This Privacy Policy explains how we collect, use, share, and protect information when you visit our website or use our services.</p>
          <h4>2. Information We Collect</h4>
          <ul>
            <li><strong>Information You Provide:</strong> Contact forms, job applications, and support requests.</li>
            <li><strong>Usage & Analytics:</strong> Aggregated data via Firebase Analytics (pages visited, device type).</li>
            <li><strong>Cookies:</strong> To remember preferences and analyze traffic.</li>
          </ul>
          <h4>3. How We Use Information</h4>
          <p>To maintain services, communicate updates, analyze trends, and comply with legal obligations.</p>
          <h4>4. Data Sharing</h4>
          <p>We do not sell personal information. We only share data with trusted service providers (hosting, analytics) or when required by law.</p>
          <h4>5. Security</h4>
          <p>We implement encryption in transit and secure hosting. No system is 100% secure; exercise caution with sensitive info.</p>
          <h4>6. Your Rights</h4>
          <p>Contact us at <a href="mailto:nexafords@gmail.com">nexafords@gmail.com</a> to access, correct, or delete your data.</p>
        </article>

        <article id="terms" className="policy">
          <h3>Terms of Service</h3>
          <p>Effective date: November 25, 2025</p>
          <h4>1. Acceptance</h4>
          <p>By using NexaFord, you agree to these Terms. If you do not agree, please discontinue use.</p>
          <h4>2. Use License</h4>
          <p>Users must comply with all local laws. Misuse or interference with operations is strictly prohibited.</p>
          <h4>3. Intellectual Property</h4>
          <p>All trademarks and logos are the property of ORPO Corporation or their respective owners.</p>
        </article>

        <article id="cookie-policy" className="policy">
          <h3>Cookie Policy</h3>
          <p>We use essential cookies for site functionality and analytics cookies to improve our product. You can manage cookie settings in your browser at any time.</p>
        </article>

        <article id="security-policy" className="policy">
          <h3>Security Policy</h3>
          <p>We secure our systems via HTTPS, strict access controls, and regular vulnerability scanning. For security disclosures, email us directly.</p>
        </article>

        <article id="data-deletion" className="policy">
          <h3>Data Deletion & Privacy Rights</h3>
          <p>Users (including GDPR/CCPA residents) may request full data deletion by emailing <a href="mailto:nexafords@gmail.com">nexafords@gmail.com</a>. We respond to all requests within 30 days.</p>
        </article>
      </section>

      {/* FINAL CALL TO ACTION */}
      <section className="cta">
        <h2>Get Started with NexaFord</h2>
        <p>Explore hand-picked AI tools and integrations for teams and creators.</p>
        <a href="#contact" className="contact-btn">Get in touch</a>
      </section>

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-grid">
          <div className="footer-col">
            <h4>ORPO Corporation</h4>
            <p>Building intelligent digital ecosystems. Nairobi, Kenya.</p>
          </div>
          <div className="footer-col">
            <h4>Explore</h4>
            <ul>
              <li><a href="#products">Products</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#careers">Careers</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><a href="#privacy-policy">Privacy Policy</a></li>
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#cookie-policy">Cookie Policy</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Contact</h4>
            <p>Email: <a href="mailto:nexafords@gmail.com">nexafords@gmail.com</a></p>
            <p><a href="/DeleteAccount.html">Request Account & Data Deletion</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} ORPO Corporation. All rights reserved.</p>
          <div className="social-links">
            <a href="#">Twitter</a> | <a href="#">Facebook</a> | <a href="#">Instagram</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;